import { Button, type ButtonProps } from '@mui/material';
import { useHistory } from 'react-router-dom';

interface NavigationButtonProps {
    title?: string;
    disabled?: boolean;
    onClick?: () => void;
}

interface NextButtonProps extends NavigationButtonProps {
    nextPath?: string;
}

interface BackButtonProps extends NavigationButtonProps {
    prevPath?: string;
    buttonProps?: ButtonProps;
}

/**
 * Reusable Next button component for StepWizard2
 */
export function NextButton({
    title = 'Next',
    nextPath = undefined,
    disabled = false,
    onClick = undefined,
}: NextButtonProps) {
    const history = useHistory();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (nextPath) {
            history.push(nextPath);
        }
    };

    return (
        <Button variant="contained" disabled={disabled} onClick={handleClick}>
            {title}
        </Button>
    );
}

/**
 * Reusable Back button component for StepWizard2
 */
export function BackButton({
    title = 'Back',
    prevPath = undefined,
    disabled = false,
    onClick = undefined,
    buttonProps,
}: BackButtonProps) {
    const history = useHistory();

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (prevPath) {
            history.push(prevPath);
        }
    };

    return (
        <Button variant="outlined" disabled={disabled} onClick={handleClick} {...buttonProps}>
            {title}
        </Button>
    );
}
